import client, {ConfigWithToken} from './client'
import {PendingActionType, PendingFormData} from 'apm/types';
import {apiReady} from "apm/utils/data_manipulator";


export const getPendingActions = async (): Promise<PendingActionType[]> => {
    try {
        const {data: response} = await client.get(`workflow/pendingactions`, ConfigWithToken()).then(response => response.data);
        return response;
    } catch (error) {
        return Promise.reject(error);
    }
}
export const getPendingAction = async (type: string|undefined, subProjectId: string|undefined, id: string|undefined, signal: AbortSignal|undefined): Promise<PendingFormData> => {
    try {
        const {data: response} = await client.get(`${type}/subproject/${subProjectId}/request/${id}`, {
            ...ConfigWithToken(),
            signal: signal
        }).then(response => response.data);
        return response;
    } catch (error) {
        return Promise.reject(error);
    }
}
export const approve = async (signal: AbortSignal, type: string, subProjectId: string,requestId: string, data: {}) => {
    try {

        const {data: response} = await client.post(`${type}/subproject/${subProjectId}/request/${requestId}/approve`,  apiReady(data), {
            ...ConfigWithToken(),
            signal: signal
        })
        return response;
    } catch (error: any) {
        if (error.response?.data) {
            return error.response.data;
        }
        console.log(error);
        return {}
    }
}
export const reject = async (signal: AbortSignal, type: string, subProjectId: string,requestId: string, data: {}) => {
    try {

        const {data: response} = await client.post(`${type}/subproject/${subProjectId}/request/${requestId}/reject`, data, ConfigWithToken(),

        )
        return response;
    } catch (error: any) {
        if (error.response?.data) {
            return error.response.data;
        }
        console.log(error);
        return {}
    }
}
export const pendingActionsCount = async () => {
    try {

        const {data: response} = await client.get(`/workflow/pendingactions/count`, ConfigWithToken()).then(response => response.data)
        return response;
    } catch (error: any) {

        return 0
    }
}
export const updateRequest = async (signal: AbortSignal, type: string, subProjectId: string,requestId: string, data: {}) => {
    try {

        const {data: response} = await client.put(`${type}/subproject/${subProjectId}/request/${requestId}`,  apiReady(data), ConfigWithToken(),

        )
        return response;
    } catch (error: any) {
        if (error.response?.data) {
            return error.response.data;
        }
        console.log(error);
        return {}
    }
}